import React from "react";
import FlashOnOutlinedIcon from "@mui/icons-material/FlashOnOutlined";
import {Failure, Passed, Warning} from "./HistoricalInstallCheck";
import {Green, Grey, Red, Yellow} from "../InstallationCheck";

function CurrentSymbol ({ averageCurrent, result }) {

    const getSymbol = () => {
        if (averageCurrent == null || averageCurrent === 0) {
            return (
                <FlashOnOutlinedIcon style={{color: Red, fontSize: 40}}/>
            );
        } else if (result === Passed) {
            return (
                <FlashOnOutlinedIcon style={{color: Green, fontSize: 40}}/>
            );
        } else if (result === Failure) {
            return (
                <FlashOnOutlinedIcon style={{color: Red, fontSize: 40}}/>
            );
        } else if (result === Warning) {
            return (
                <FlashOnOutlinedIcon style={{color: Yellow, fontSize: 40}}/>
            );
        } else {
            return (
                <FlashOnOutlinedIcon style={{color: Grey, fontSize: 40}}/>
            );
        }
    };

    return (
        getSymbol()
    );
}

export default CurrentSymbol;